import { getPath } from '@epic-core/common';
import React from 'react';
import { Redirect } from './Redirect';
import { ServerRoute } from './routes';
import root from 'window-or-global';

export const getMetahumanRedirects = (): ServerRoute[] => {
    const path = getPath();

    const clientConfig = root.clientEnvConfig || {};
    const EPIC_UE_MH_REDIRECT_BASE_URL =
        clientConfig && clientConfig.EPIC_UE_MH_REDIRECT_BASE_URL;
    if (!EPIC_UE_MH_REDIRECT_BASE_URL) {
        throw new Error('routes missing EPIC_UE_MH_REDIRECT_BASE_URL');
    }
    const mhSite = EPIC_UE_MH_REDIRECT_BASE_URL;

    return [
        {
            path: `${path}:locale/blog/metahuman-comes-to-uefn-dynamic-clothing-with-marvelous-designer-and-more`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/metahuman-comes-to-uefn-dynamic-clothing-with-marvelous-designer-and-more`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/spotlights/behind-the-scenes-on-blue-dot-metahuman-animator-brings-stunning-fidelity-to-cinematics`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/spotlights/behind-the-scenes-on-blue-dot-metahuman-animator-brings-stunning-fidelity-to-cinematics`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/delivering-high-quality-facial-animation-in-minutes-metahuman-animator-is-now-available`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/delivering-high-quality-facial-animation-in-minutes-metahuman-animator-is-now-available`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/spotlights/meet-mave-the-virtual-k-pop-stars-created-with-unreal-engine-and-metahuman`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/developer-interviews/meet-mave-the-virtual-k-pop-stars-created-with-unreal-engine-and-metahuman`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/new-metahuman-animator-feature-set-to-bring-easy-high-fidelity-performance-capture-to-metahumans`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/new-metahuman-animator-feature-set-to-bring-easy-high-fidelity-performance-capture-to-metahumans`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/new-metahuman-release-brings-easier-sharing-and-dna-calibration`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/new-metahuman-release-brings-easier-sharing-and-dna-calibration`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/spotlights/metahuman-technology-brings-a-10-000-year-old-shaman-back-to-life`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/spotlights/metahuman-technology-brings-a-10-000-year-old-shaman-back-to-life`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/new-release-brings-mesh-to-metahuman-to-unreal-engine-and-much-more`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/new-release-brings-mesh-to-metahuman-to-unreal-engine-and-much-more`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/a-sneak-peek-at-metahuman-creator-high-fidelity-digital-humans-made-easy`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/a-sneak-peek-at-metahuman-creator-high-fidelity-digital-humans-made-easy`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/early-access-to-metahuman-creator-is-now-available`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/news/early-access-to-metahuman-creator-is-now-available`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/the-tech-behind-metahuman-creator-face-rigs`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/learning/the-tech-behind-metahuman-creator-face-rigs`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/blog/now-available-video-guide-on-using-the-metahuman-facial-rig`,
            element: (
                <Redirect
                    url={`${mhSite}:locale/learning/now-available-video-guide-on-using-the-metahuman-facial-rig`}
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${path}:locale/metahuman-creator-apply`,
            element: <Redirect url={`${mhSite}:locale/download`} status={301} replace />
        },
        {
            path: `${path}:locale/metahuman`,
            element: <Redirect url={`${mhSite}:locale`} status={301} replace />
        }
    ];
};
